var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-4"},[_c('Player',{attrs:{"src":_vm.studyUrl},on:{"ended":_vm.onVideoEnd}})],1),_c('div',{staticClass:"px-4"},[_c('van-button',{attrs:{"block":"","disabled":!_vm.videoEnd,"type":"primary"},on:{"click":_vm.onExamination}},[_c('span',[_vm._v(_vm._s(_vm.videoEnd ? '考试' : '请先观看视频'))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }